import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';
import { cloneElement, forwardRef, useImperativeHandle } from 'react';

const DynamicVerifyPopup = dynamic(() => import('./VerifyEmailPopup'), {
  ssr: false
});

type IProps = {
  email: string;
  isSign: boolean;
  onSuccess?: (param?) => void;
  handleClose?: () => void;
  children?: any;
  entry?: string;
  source?: string;
  isWithoutPasswordLogin?: boolean;
};

const VerifyEmailModal = forwardRef((props: IProps, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  const { children, ...rest } = props;

  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });

  if (!visible) return null;

  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: show
        })}
      {loaded && <DynamicVerifyPopup {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default VerifyEmailModal;
